var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25C9.59334 8.25 10.1734 8.07405 10.6667 7.74441C11.1601 7.41477 11.5446 6.94623 11.7716 6.39805C11.9987 5.84987 12.0581 5.24667 11.9424 4.66473C11.8266 4.08279 11.5409 3.54824 11.1213 3.12868C10.7018 2.70912 10.1672 2.4234 9.58527 2.30765C9.00333 2.19189 8.40013 2.2513 7.85195 2.47836C7.30377 2.70543 6.83524 3.08994 6.50559 3.58329C6.17595 4.07664 6 4.65666 6 5.25C6 6.04565 6.31607 6.80871 6.87868 7.37132C7.44129 7.93393 8.20435 8.25 9 8.25ZM13.5 15.75C13.6989 15.75 13.8897 15.671 14.0303 15.5303C14.171 15.3897 14.25 15.1989 14.25 15C14.25 13.6076 13.6969 12.2723 12.7123 11.2877C11.7277 10.3031 10.3924 9.75 9 9.75C7.60761 9.75 6.27226 10.3031 5.28769 11.2877C4.30312 12.2723 3.75 13.6076 3.75 15C3.75 15.1989 3.82902 15.3897 3.96967 15.5303C4.11032 15.671 4.30109 15.75 4.5 15.75H13.5Z",
    fill: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d4e7e4986affed731f662fafa017a7e0.svg";
export { ForwardRef as ReactComponent };